<template>
  <div class="body edit-panel flex flex-col gap-4">

    <div
      v-if="item.asset_type === 'video'"
      class="mb-5"
    >
      <p class="tb-label">Video Controls</p>

      <div class="tb-checkbox">
        <input
          type="checkbox"
          id="videoLoop"
          v-model="loop"
          data-test="asset-editor-loop"
        />

        <label for="videoLoop">Loop Video</label>
      </div>
    </div>

    <div class="flex gap-[10px]">
      <div>
        <div v-if="imagePreview" class="media-upload-wrapper">
          <div class="media" :style="{ 'background-image' : 'url(' + imagePreview + ')' }"></div>

          <div class="edit-media">
            <button
              class="tb-btn tb-btn-contained on-image"
              data-entity="producer-editor-editBackgroundImage"
              data-test="graphics-editor-image-select"
              @click="selectAsset"
            >
              <span class="fas fa-pencil-alt"></span>
            </button>
          </div>
        </div>

        <button
          v-else
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-editor-selectBackgroundImage"
          data-test="graphics-editor-image-select"
          @click="selectAsset"
        >
          <span class="fas fa-image mr-1"></span>
          Choose image
        </button>
      </div>

      <div class="flex-grow">
        <div class="tb-form-group mb-4">
          <label class="tb-label">Title</label>

          <input
            class="tb-input"
            type="text"
            v-model="title"
            data-test="asset-editor-title"
            @keyup.right.stop
            @keyup.left.stop
          />
        </div>

        <div class="tb-form-group mb-0">
          <label class="tb-label">Fill type</label>

          <select
            class="tb-select"
            data-test="asset-editor-fillType"
            v-model="fillType"
          >
            <option value="contain">Fit</option>
            <option value="cover">Fill</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { debounce } from 'lodash-es';

import editingMixins from '../../mixins/editing-mixins';

export default {
  name: 'AssetEditor',
  mixins: [editingMixins],
  props: ['editing', 'item'],
  computed: {
    title: {
      get() {
        return this.item.title;
      },
      set: debounce(function(value) {
        this.setTimelineTitle({
          timelineId: this.editing?.timeline_id,
          title: value,
        });

        this.updateTimeline();
        this.updatePreviewTimeline();
      }, 500),
    },

    currentLayoutIndex() {
      return this.$store.state.production.production.index;
    },

    isCurrentLayout() {
      return this.item && (this.editing.timeline_id === this.currentLayoutIndex);
    },

    currentSampleLayoutIndex() {
      return this.$store.state.preview.production.index;
    },

    isCurrentSampleLayout() {
      return this.item && (this.currentSampleLayoutIndex === this.editing.timeline_id);
    },

    assetFields() {
      return {
        ...this.editing,
        ...this.editing.fields,
      };
    },

    imagePreview() {
      return this.assetFields.thumbnail_url || this.assetFields.media_url;
    },

    fillType: {
      get() {
        return this.assetFields.fillType || 'contain';
      },
      set(value) {
        this.setField('fillType', value);
      },
    },

    loop: {
      get() {
        return this.assetFields.loop || false;
      },
      set(value) {
        this.setField('loop', value);
      },
    },
  },
  methods: {
    ...mapActions([
      'setTimelineTitle',
      'updateTimeline',
      'updatePreviewTimeline',
      'toggleAssetModal',
    ]),

    selectAsset() {
      this.toggleAssetModal({ toggled: true, type: this.item.asset_type });

      window.assetmanfn = (asset, meta = {}) => {
        if (this.item.asset_type === 'video') {
          this.setField('thumbnail_url', asset.thumbnail_url);
        }

        this.setField('media_url', asset.media_url);
        this.setField('mediaMeta', meta);

        this.toggleAssetModal({ toggled: false, type: this.item.asset_type });
      };
    },
  },
};
</script>
